// extracted by mini-css-extract-plugin
export var divider = "_pn-0";
export var systemMessage = "_pn-1";